import styled from "styled-components";

export const LogoWrapper = styled.div``;

export const LogoImg = styled.img``;
